import { useAuthStore } from '@/stores/retailer/auth.js'

export default function retailerCompanyActivityControl(to, from, next) {
  const authStore = useAuthStore()

  if (authStore.getToken) {
    authStore.getUser().then(user => {
      if (user.retailer.address.neighborhood_id) {
        next({ name: 'retailer.dashboard' })
      } else {
        next()
      }
    })
  } else {
    next()
    return
  }
}
